import { render, staticRenderFns } from "./FooterApp.vue?vue&type=template&id=36eaaded"
import script from "./FooterApp.vue?vue&type=script&lang=js"
export * from "./FooterApp.vue?vue&type=script&lang=js"
import style0 from "./FooterApp.vue?vue&type=style&index=0&id=36eaaded&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports